/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, March 1st 2022, 9:41:09 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

export enum SERVICE_BUILDER_ACTIONS {
  SET_FETCH_PROCESS_DEFINITION_STATUS,
  SET_PATCH_PROCESS_DEFINITION_STATUS,
  SET_CURRENT_PROCESS_DEFINITION,
  SET_NEW_STATUS_FOR_CURRENT_PROCESS_DEFINITION,
}
